import { BorderWidthType, MarginType, PaddingType } from '../types/stylesTypes'

export const hashToStyles = (styleHash: any) => {
  let result = ''

  const keys = Object.keys(styleHash)

  for (let key of keys) {
    if (result) {
      result += '; '
    }

    result += key + ': ' + styleHash[key]
  }

  return result
}

export const toPx = (value: string | number) => {
  if (!value) {
    return '0'
  }
  if (typeof value === 'string' && value.endsWith('px')) {
    return value
  }

  return `${value}px`
}

interface StylesType {
  marginTop: number
  marginLeft: number
  marginBottom: number
  marginRight: number
  paddingTop: number
  paddingRight: number
  paddingBottom: number
  paddingLeft: number
}

interface StylesWithMarginsAndPaddingsType extends StylesType {
  [key: string]: number | string
}

export function splitMarginsAndRestStyles(styles: StylesWithMarginsAndPaddingsType) {
  const { marginTop, marginLeft, marginBottom, marginRight, ...restStyles } = styles
  return [
    {
      marginTop,
      marginLeft,
      marginBottom,
      marginRight,
    },
    restStyles,
  ]
}

export function splitMarginsAndPaddingAndRestStyles(styles: any) {
  const {
    marginTop,
    marginLeft,
    marginBottom,
    marginRight,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    ...restStyles
  } = styles
  return [
    {
      marginTop,
      marginLeft,
      marginBottom,
      marginRight,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
    },
    restStyles,
  ]
}

function sanitizeNumericValue(value: any, allowNegative: boolean = false): number {
  if (value == null || isNaN(value)) {
    return 0
  }
  if (!allowNegative && value < 0) {
    return 0
  }
  return value
}

export function sanitizePadding(padding: any): PaddingType {
  if (!padding || typeof padding !== 'object') {
    return {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    }
  }

  return {
    paddingTop: sanitizeNumericValue(padding.paddingTop, false),
    paddingRight: sanitizeNumericValue(padding.paddingRight, false),
    paddingBottom: sanitizeNumericValue(padding.paddingBottom, false),
    paddingLeft: sanitizeNumericValue(padding.paddingLeft, false),
  }
}

export function sanitizeMargin(margin: any): MarginType {
  if (!margin || typeof margin !== 'object') {
    return {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    }
  }

  return {
    marginTop: sanitizeNumericValue(margin.marginTop, true),
    marginRight: sanitizeNumericValue(margin.marginRight, true),
    marginBottom: sanitizeNumericValue(margin.marginBottom, true),
    marginLeft: sanitizeNumericValue(margin.marginLeft, true),
  }
}

export function sanitizeBorderWidth(borderWidth: any): BorderWidthType {
  if (!borderWidth || typeof borderWidth !== 'object') {
    return {
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
    }
  }

  return {
    borderTopWidth: sanitizeNumericValue(borderWidth.borderTopWidth, false),
    borderRightWidth: sanitizeNumericValue(borderWidth.borderRightWidth, false),
    borderBottomWidth: sanitizeNumericValue(borderWidth.borderBottomWidth, false),
    borderLeftWidth: sanitizeNumericValue(borderWidth.borderLeftWidth, false),
  }
}
